(function() { module.exports = (typeof self !== 'undefined' ? self : this)["React"]; }());